import { render, staticRenderFns } from "./NewShopWeb.vue?vue&type=template&id=5816b8ee&"
import script from "./NewShopWeb.vue?vue&type=script&lang=js&"
export * from "./NewShopWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports